import { render, staticRenderFns } from "./PageStatus.vue?vue&type=template&id=23f3cd14&scoped=true&"
import script from "./PageStatus.vue?vue&type=script&lang=js&"
export * from "./PageStatus.vue?vue&type=script&lang=js&"
import style0 from "./PageStatus.vue?vue&type=style&index=0&id=23f3cd14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f3cd14",
  null
  
)

component.options.__file = "PageStatus.vue"
export default component.exports